<template>
  <el-dialog
    :visible="dialogShow"
    :before-close="beforeClose"
    :title="title"
    width="614px"
    class="wechat-list-dialog"
  >
    <div class="form-content">
      <i class="el-icon-warning-outline theme-color icon-btn"></i>
      确定对
      <span class="theme-color">[{{rowData.botName}}]</span>
      进行上线操作?
    </div>
    <div slot="footer"  class="footer">
      <el-button
        type="primary"
        :loading="loading"
        @click="confirm"
      >确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { loginWechat } from "@/api/wechat/wechat-list";

export default {
  name: "loginConfirmDialog",
  components: {
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    rowData:{
      type: Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {
      title: '提示',
      loading: false,
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.loading = true;
      loginWechat(this.rowData.id).then((res) => {
        if (res && res.code === 200) {
          this.loading = false;
          this.$emit('confirm-success',res);
        } else {
          this.loading = false;
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        this.loading = false;
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wechat-list-dialog {
  .form-content {
    text-align: center;
    font-size: 16px;
    color: #4B4B4B;
  }
  .icon-btn {
    font-size: 20px;
    font-weight: bold;
  }
  /deep/ .el-dialog__header {
    .el-dialog__title {
      font-weight: 500;
    }
    background-color: #F8F8F8;
    padding-bottom: 20px;
    .el-icon-close {
      color: #4B4B4B;
      font-weight: bold;
    }
  }
  /deep/ .el-dialog__body {
    border-bottom: 1px solid #E0E4F2;
  }
  .footer {
    text-align: center;
  }
}
</style>
